import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Dialog, DialogTitle } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import createDeviceDialogSx from '../../../_shared/sxStyles/Device/CreateDeviceDialogSx';
import CreateMultipleDevicesForm from './CreateDeviceDialog/MultipleDevices/CreateMultipleDevicesForm';

interface DeviceCreationSelectorProps {
  setOpen: Dispatch<SetStateAction<boolean>>;
  setConfirmOpen: Dispatch<SetStateAction<boolean>>;
  setErrorMessage: Dispatch<SetStateAction<string | null>>;
}

function DeviceCreationSelector({
  setOpen,
  setConfirmOpen,
  setErrorMessage,
}: DeviceCreationSelectorProps) {
  return (
    <Dialog
      open
      fullWidth
      maxWidth='sm'
      PaperProps={{
        sx: createDeviceDialogSx.dialogPaper,
      }}
    >
      <DialogTitle>
        <FormattedAlias id='Create Devices' />
      </DialogTitle>

      <CreateMultipleDevicesForm
        setOpen={setOpen}
        setConfirmOpen={setConfirmOpen}
        setErrorMessage={setErrorMessage}
      />
    </Dialog>
  );
}

export default DeviceCreationSelector;
